export function parseStartParam(startParam, key) {
  if (!startParam) return null
  const [k, value] = startParam.split('-', 2)
  return k === key ? value : null
}
